import signupSuccessImage from '../static/brand/signup-success.png';
import laiguLogo from '../static/brand/logo/laigu/favicon.ico';
import settingsEmptyImage from '../static/brand/settings-empty.png';
import unverifiedIdentityImage from '../static/brand/indentity.png';
import baiduBcpEmptyImage from '../static/brand/emptypag_baidu.png';

// 来鼓品牌资源与服务地址。
export const BRAND_RESOURCES = {
  enterpriseName: '来鼓',
  paymentPath: '/setting/payment/',
  supportChatUrl: 'https://laigu.com/chatlink.html?',
  favicon: laiguLogo,
  supportEmail: 'team@laigu.com',
  helpCenterUrl: 'https://lcn8x2akkv95.feishu.cn/wiki/NqpnwasKtiYLcnkdmf3czw0FnDf?fromScene=spaceOverview',
  signupSuccessImage,
  logoIcon: 'ecoboost-iconfontlaigu1',
  agreementUrl: 'https://laigu.com/agreements/',
  customerSearchEmptyIcon: 'ecoboost-iconfontemptypag_general_05',
  defaultEmptyIcon: 'ecoboost-iconfontemptypag_tickets_02',
  quickReplyEmptyIcon: 'ecoboost-iconfontemptypag_general_02',
  callSettingsEmptyIcon: 'ecoboost-iconfontemptypag_tickets_022',
  settingsEmptyImage,
  conversationListEmptyIcon: 'ecoboost-iconfontemptypag_chat_01',
  noConversationIcon: 'ecoboost-iconfontemptypag_chat_02',
  transferEmptyIcon: 'ecoboost-iconfontemptypag_chat_06',
  unverifiedIdentityImage,
  networkCheckUrls: 'https://app.laigu.com,https://eco-push-api-agent.laigu.com',
  privacyUrl: 'https://laigu.com/privacy/',
  noPermissionIcon: 'ecoboost-iconfontemptypag_chat_031',
  onlineSupportUrl: 'https://laigu.com/chatlink.html?subSource=sub_source_9',
  baiduBcpEmptyImage,
  webhooksDocsUrl: 'https://lcn8x2akkv95.feishu.cn/wiki/YOghwi4gkikQfakexKMcoRzDncc'
};
